import E from 'wangeditor';
import * as React from 'react';

/** props */
interface Props {
  onChange?: (value: string | null) => void;
  value?: string;
}

/** state */
interface State {
  editorContent: string;
  editorRef: any | null;
}

/** 菜单配置项 */
const menu: string[] = [
  'head',
  'bold',
  'fontSize',
  'fontName',
  'italic',
  'underline',
  'strikeThrough',
  'indent',
  'lineHeight',
  'foreColor',
  // 'backColor',
  // 'link',
  // 'list',
  // 'todo',
  'justify',
  // 'quote',
  // 'emoticon',
  // 'image',
  // 'video',
  // 'table',
  // 'code',
  // 'splitLine',
  // 'undo',
  // 'redo',
]

class RicheEditor extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const html = props.value ? props.value : '';
    this.state = {
      editorContent: html,
      editorRef: null,
    }
  }

  componentDidMount() {
    this.initEditor();
  }

  componentWillUnmount() {
    const { editorRef } = this.state;
    if (editorRef) {
      editorRef.destroy();
      this.setState({
        editorRef: null,
      })
    }
  }

  /** 初始化wangEditor */
  initEditor = (): any => {
    const { editorContent } = this.state;
    const eleMenu = '#editor-menu';
    const elemBody = '#editor-body';
    const editor = new E(eleMenu, elemBody);
    this.setState({
      editorRef: editor,
    })
    // editor.config.onblur = this.triggerChange;
    editor.config.onchange = this.triggerChange;

    editor.config.onchangeTimeout = 500;
    editor.config.menus = menu;
    editor.config.uploadImgShowBase64 = false;
    editor.create();
    editor.txt.html(editorContent);
  }

  triggerChange = (html: string): void => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(html);
    }
  }

  render() {
    return (
      <div className='editor-wrapper'>
        <div className="editor-menu" id="editor-menu" >
          {/* 编辑菜单 */}
        </div>
        <div className="editor-body" id="editor-body" >
          {/* 编辑主题 */}
        </div>
      </div>
    )
  }
}

export default RicheEditor;


// WEBPACK FOOTER //
// ./src/components/common/RichEditor.tsx